import { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";

export const WelcomeGifts = ({ gifts = [], name }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => { if (gifts.length && !sessionStorage.getItem("rathri_welcome")) { setOpen(true); sessionStorage.setItem("rathri_welcome", "1"); } }, [gifts.length]);
  if (!open) return null;
  return (
    <div data-testid="welcome-gifts-modal" className="fixed inset-0 z-[65] flex items-center justify-center p-4" onClick={() => setOpen(false)}>
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative card rounded-3xl p-5 w-full max-w-sm fade-up" onClick={(e) => e.stopPropagation()}>
        <button data-testid="welcome-close" onClick={() => setOpen(false)} className="absolute top-3 right-3 btn-ghost w-8 h-8 rounded-full inline-flex items-center justify-center"><X size={14} /></button>
        <p className="label-caps inline-flex items-center gap-1"><Sparkles size={12} /> സ്വാഗതം{name ? `, ${name}` : ""}</p>
        <h3 className="font-display text-lg font-bold mt-1">🎁 വിർച്ച്വൽ ഗിഫ്റ്റുകൾ</h3>
        <p className="text-xs text-[var(--muted-text)] mt-1">കോളിലും ചാറ്റിലും സ്റ്റാഫിന് ഗിഫ്റ്റ് അയക്കാം — ഗിഫ്റ്റ് ബോക്സ് തുറക്കുന്ന ആനിമേഷനോടെ!</p>
        <div className="grid grid-cols-4 gap-2 mt-4">
          {gifts.map((g) => <div key={g.id} data-testid={`welcome-gift-${g.id}`} className="rounded-2xl bg-[var(--bg)] border border-[var(--line)] p-2 text-center"><div className="text-2xl leading-none tracking-tighter">{g.emoji}</div><p className="text-[10px] font-semibold mt-1 truncate">{g.name}</p><p className="font-num text-[10px] text-[var(--muted-text)] font-bold">₹{g.cost / 6}</p></div>)}
        </div>
        <button data-testid="welcome-ok" onClick={() => setOpen(false)} className="btn-accent w-full rounded-full h-10 text-sm font-bold mt-4">തുടരുക</button>
      </div>
    </div>
  );
};
